import { useCallback, useEffect, useRef, useState } from 'react';

export function useRemoteStatusSummary({ config, debugLog, fetchApplicationFileStatusSummary, managementApiService }) {
  const [remoteStatusSummary, setRemoteStatusSummary] = useState(null);
  const remoteStatusSummaryRef = useRef(null);

  useEffect(() => {
    remoteStatusSummaryRef.current = remoteStatusSummary;
  }, [remoteStatusSummary]);

  const resetRemoteStatusSummary = useCallback(() => {
    remoteStatusSummaryRef.current = null;
    setRemoteStatusSummary(null);
  }, []);

  const refreshRemoteStatusSummary = useCallback(async () => {
    const snapshot = {
      hasBaseUrl: Boolean(managementApiService?.baseUrl),
      caseId: config.caseId || '',
      clientId: config.clientId || '',
      applicationNumber: config.applicationNumber || '',
      role: config.role || ''
    };

    debugLog('refresh-remote-status-summary-called', snapshot);

    try {
      const summary = await fetchApplicationFileStatusSummary(managementApiService, config);
      remoteStatusSummaryRef.current = summary;
      setRemoteStatusSummary(summary);
      debugLog('refresh-remote-status-summary-completed', {
        ...snapshot,
        hasSummary: Boolean(summary)
      });
      return summary;
    } catch (error) {
      debugLog('refresh-remote-status-summary-failed', {
        ...snapshot,
        message: error?.message || 'Unknown error'
      });
      remoteStatusSummaryRef.current = null;
      setRemoteStatusSummary(null);
      return null;
    }
  }, [config.caseId, config.clientId, config.applicationNumber, config.role, debugLog, fetchApplicationFileStatusSummary, managementApiService]);

  return {
    remoteStatusSummary,
    remoteStatusSummaryRef,
    refreshRemoteStatusSummary,
    resetRemoteStatusSummary
  };
}
